import { Tags } from 'framework/tags'
import { EcommerceService } from 'services'

class TagService extends EcommerceService {
  getTags() {
    const self = this
    const url = '/tags'
    const req = self.setUrl(url).get()
    return req
  }

  getCategoryById(tagId: string) {
    const self = this
    const url = `/tags/${tagId}`
    const req = self.setUrl(url).get()
    return req
  }

  parser(data: any[]): Tags {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const self = this
    const tags = (data
      .map((item) => {
        if (item.slug !== '') {
          return {
            id: item.id,
            slug: item.slug,
            name: item.descricao,
          }
        }

        return null
      })
      .filter(Boolean) as unknown) as Tags
    return tags
  }
}

export default TagService
